import { useCallback, useEffect } from 'react';

import { sidebarActions } from 'applications/GSP/layouts/MainLayout/components/Sidebar/store';
import {
  useAppDispatch,
  useAppSelector,
} from 'applications/GSP/shared/hooks/store';
import { useMediaQuery } from 'shared/hooks/dom';
import { logout } from 'shared/utils/router';

import { HeaderDesktop } from './components/HeaderDesktop';
import { HeaderMobile } from './components/HeaderMobile';

import type { FC } from 'react';

export const HEADER_TEST_ID = 'header';

export const Header: FC = () => {
  const matches = useMediaQuery('md');
  const dispatch = useAppDispatch();
  const { opened } = useAppSelector(state => state.sidebar);

  const toggleSidebar = useCallback(() => {
    dispatch(sidebarActions.setSidebarState(!opened));
  }, [dispatch, opened]);

  useEffect(() => {
    dispatch(sidebarActions.setSidebarState(matches));
  }, [dispatch, matches]);

  return matches ? (
    <HeaderDesktop onLogout={logout} />
  ) : (
    <HeaderMobile onLogout={logout} toggleSidebar={toggleSidebar} />
  );
};
